import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import Data from "source/app/services/Data";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { ICalendarEvent } from "../../../../../../../../../motw_core/Calendar/ICalendarEvent";
import { ReadState } from "../../../../../../services/UI/State/ReadState";
import { ICalendarState } from "../../../ICalendarState";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";
import { WithCalendarEventsChangingIndicatorAsync } from "./WithCalendarEventsChangingIndicatorAsync";

export async function UpdateCalendarEventAsync(withEventData?: ICalendarEvent) {
    const calendarEvent: ICalendarEvent =
        typeof withEventData === `object` // beacause swal button might pass in a boolean
            ? withEventData
            : ReadState<ICalendarEventEditorState>(
                  ESharedFunction.CalendarEventEditor_state
              )!.calendarEvent;

    await WithCalendarEventsChangingIndicatorAsync(calendarEvent, async () => {
        await WithAnimatedProgressBarAsync(() =>
            MotwLogicServer.UpdateCalendarEventAsync(calendarEvent)
        );

        await Data.Load.Single.ByStateTarget<ICalendarState>(`eventData`);
    });
}
